import { IConfiguration } from "./IConfiguration";

export const PROD = {
	headerAuthWidgetsApiUrl: "https://findum-widgets.sendum.com",
	headerAuthWidgetsApiVersion: "v1",
	baseApiPath: "widget",
	mqttPrefix: "",
	awsRegion: "us-west-2",
	cognitoAuthWidgetsApiUrl: "https://dapi3dt7zd.execute-api.us-west-2.amazonaws.com",
	cognitoAuthWidgetsApiVersion: "prod",
	cognitoAuthApiUrl: "https://w5ik9xhlej.execute-api.us-west-2.amazonaws.com",
	cognitoAuthApiVersion: "prod",
	cognitoIdentityPoolId: "us-west-2:83ae71b3-ed10-400a-bc07-b61ce952ac72",
	cognitoAuthProviderName: "login.sendum.myapp",
	voyagerApiUrl: 'https://dhkxxt8r65.execute-api.us-west-2.amazonaws.com',
	voyagerApiVersion: 'prod'
} as IConfiguration;